import MasonryGrid from "../MasonryGrid";
import { ProgressCardSkeleton } from "./ProgressCardSkeleton";

const TITLE_WIDTHS = ["70%", "55%", "62%"] as const;

type Props = {
	numCards?: number;
};

export const ProgressViewSkeleton = ({ numCards = 4 }: Props) => (
	<MasonryGrid>
		{Array.from({ length: numCards }).map((_, cardIndex) => (
			<ProgressCardSkeleton
				// biome-ignore lint/suspicious/noArrayIndexKey: static skeleton cards
				key={cardIndex}
				titleWidth={TITLE_WIDTHS[cardIndex % TITLE_WIDTHS.length]}
			/>
		))}
	</MasonryGrid>
);
